/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as ProjectsRouteImport } from './routes/projects'
import { Route as PlanRouteImport } from './routes/plan'
import { Route as PaymentRouteImport } from './routes/payment'
import { Route as OnboardingRouteImport } from './routes/onboarding'
import { Route as IdeRouteImport } from './routes/ide'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as ArchiveRouteImport } from './routes/archive'
import { Route as IndexRouteImport } from './routes/index'

const ProjectsRoute = ProjectsRouteImport.update({
  id: '/projects',
  path: '/projects',
  getParentRoute: () => rootRouteImport,
} as any)
const PlanRoute = PlanRouteImport.update({
  id: '/plan',
  path: '/plan',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentRoute = PaymentRouteImport.update({
  id: '/payment',
  path: '/payment',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardingRoute = OnboardingRouteImport.update({
  id: '/onboarding',
  path: '/onboarding',
  getParentRoute: () => rootRouteImport,
} as any)
const IdeRoute = IdeRouteImport.update({
  id: '/ide',
  path: '/ide',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const ArchiveRoute = ArchiveRouteImport.update({
  id: '/archive',
  path: '/archive',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/archive': typeof ArchiveRoute
  '/auth': typeof AuthRoute
  '/ide': typeof IdeRoute
  '/onboarding': typeof OnboardingRoute
  '/payment': typeof PaymentRoute
  '/plan': typeof PlanRoute
  '/projects': typeof ProjectsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/archive': typeof ArchiveRoute
  '/auth': typeof AuthRoute
  '/ide': typeof IdeRoute
  '/onboarding': typeof OnboardingRoute
  '/payment': typeof PaymentRoute
  '/plan': typeof PlanRoute
  '/projects': typeof ProjectsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/archive': typeof ArchiveRoute
  '/auth': typeof AuthRoute
  '/ide': typeof IdeRoute
  '/onboarding': typeof OnboardingRoute
  '/payment': typeof PaymentRoute
  '/plan': typeof PlanRoute
  '/projects': typeof ProjectsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/archive'
    | '/auth'
    | '/ide'
    | '/onboarding'
    | '/payment'
    | '/plan'
    | '/projects'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/archive'
    | '/auth'
    | '/ide'
    | '/onboarding'
    | '/payment'
    | '/plan'
    | '/projects'
  id:
    | '__root__'
    | '/'
    | '/archive'
    | '/auth'
    | '/ide'
    | '/onboarding'
    | '/payment'
    | '/plan'
    | '/projects'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ArchiveRoute: typeof ArchiveRoute
  AuthRoute: typeof AuthRoute
  IdeRoute: typeof IdeRoute
  OnboardingRoute: typeof OnboardingRoute
  PaymentRoute: typeof PaymentRoute
  PlanRoute: typeof PlanRoute
  ProjectsRoute: typeof ProjectsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/projects': {
      id: '/projects'
      path: '/projects'
      fullPath: '/projects'
      preLoaderRoute: typeof ProjectsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/plan': {
      id: '/plan'
      path: '/plan'
      fullPath: '/plan'
      preLoaderRoute: typeof PlanRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payment': {
      id: '/payment'
      path: '/payment'
      fullPath: '/payment'
      preLoaderRoute: typeof PaymentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboarding': {
      id: '/onboarding'
      path: '/onboarding'
      fullPath: '/onboarding'
      preLoaderRoute: typeof OnboardingRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ide': {
      id: '/ide'
      path: '/ide'
      fullPath: '/ide'
      preLoaderRoute: typeof IdeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/archive': {
      id: '/archive'
      path: '/archive'
      fullPath: '/archive'
      preLoaderRoute: typeof ArchiveRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ArchiveRoute: ArchiveRoute,
  AuthRoute: AuthRoute,
  IdeRoute: IdeRoute,
  OnboardingRoute: OnboardingRoute,
  PaymentRoute: PaymentRoute,
  PlanRoute: PlanRoute,
  ProjectsRoute: ProjectsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
